export default {
  path: '/settings',
  component: () => import(
    /* webpackChunkName: "settings" */
    /* webpackPrefetch: true */
    './index.vue'
  ),
  children: [
    {
      path: 'weekends',
      name: 'Weekends',
      component: () => import(
        /* webpackChunkName: "settings-weekends" */
        /* webpackPrefetch: true */
        './Weekends'
      ),
    },
  ],
};
